import { render } from "./brand_list.vue?vue&type=template&id=5f66f104"
import script from "./brand_list.vue?vue&type=script&lang=js"
export * from "./brand_list.vue?vue&type=script&lang=js"

import "./brand_list.vue?vue&type=style&index=0&id=5f66f104&scope=true&lang=css"

import exportComponent from "/var/jenkins_home/uat/ydd-zht-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__